import UploadComponent from "./UploadComponent";
export default UploadComponent;
